import React from 'react';

import { Controller } from 'react-hook-form';

import { JournalEventsFilesUploader } from '@features';

import { IFormFieldProps } from '../../../model/types';

export const AttachmentsField = ({ control, isDisabled }: IFormFieldProps) => (
    <Controller
        name="attachments"
        control={control}
        render={({ field }) => (
            <JournalEventsFilesUploader
                attachments={field.value}
                setAttachments={field.onChange}
                isDisabled={isDisabled}
            />
        )}
    />
);
